import { ajax } from '@/api'

export default {
    /**
     * 11.2新增项目
     */
    editproduct( data ) {
        const url = '/product/editproduct'

        return ajax({ url, data, method: 'post' })
    },
	/**
	 * 11.3查询项目
	 */
	queryproduct( data ) {
	    const url = '/product/queryproduct'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.4删除
	 */
	delproduct( data ) {
	    const url = '/product/delproduct'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.6查询终端
	 */
	queryterminal( data ) {
	    const url = '/terminal/queryterminal'

	    return ajax({ url, data, method: 'post' })
	},
  queryTerminalForOta( data ) {
    const url = '/terminal/terminalforota'

    return ajax({ url, data, method: 'post' })
  },

	/**
	 * 11.5新增终端
	 */
	editterminal( data ) {
	    const url = '/terminal/editterminal'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.7 删除终端
	 */
	delterminal( data ) {
	    const url = '/terminal/delterminal'

	    return ajax({ url, data, method: 'post' })
	},

	/**
	 * 11.8新增分组
	 */
	editgroup( data ) {
	    const url = '/group/editgroup'

	    return ajax({ url, data, method: 'post' })
	},
  copygroup( data ) {
    const url = '/group/copygroup'

    return ajax({ url, data, method: 'post' })
  },
	/**
	 * 11.9查询分组
	 */
	querygroup( data ) {
	    const url = '/group/querygroup'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.10查询分组参数列表
	 */
	querygroupparams( data ) {
	    const url = '/group/querygroupparams'

	    return ajax({ url, data, method: 'post' })
	},

  exportData( data ) {
    const url = '/group/export'

    return ajax({ url, data, method: 'post' })
  },
	/**
	 * 11.12删除分组
	 */
	delgroup( data ) {
	    const url = '/group/delgroup'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.14删除参数
	 */
	delparam( data ) {
	    const url = '/param/delparam'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 *  11.22查询公共分组信息
	 */
	querycommongroup( data ) {
	    const url = '/commongroup/querycommongroup'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.23查询公共分组参数列表
	 */
	querycommongroupparams( data ) {
	    const url = '/commongroup/querycommongroupparams'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.17查询组的分类信息
	 */
	querycategory( data ) {
	    const url = '/category/querycategory'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 添加串号
	 */
	addsn( data ) {
	    const url = '/sn/addsn'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.24获取串号信息
	 */
	queryserialno( data ) {
	    const url = '/serialno/queryserialno'

	    return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.13对分组添加参数
	 */
	saveparam( data ){
	  const url = "/param/saveparam"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.15新增组的分类信息
	 */
	editcategory( data ){
	  const url = "/category/editcategory"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 公共分组取消关联
	 */
	editparamDeleteGrouId( data ){
	  const url = "/param/editparamDeleteGrouId"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.16删除组的分类信息
	 */
	delcategory( data ){
	  const url = "/category/delcategory"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 参数查询
	 */
	queryterminalparams( data ){
	  const url = "/group/queryterminalparams"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 禁用启用
	 */
	setgroupstatus( data ){
	  const url = "/group/setgroupstatus"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 取消默认和设置默认
	 */
	setgroupDefaultReturn( data ){
	  const url = "/group/setgroupDefaultReturn"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 参数 编辑
	 */
	editparam( data ){
	  const url = "/param/editparam"
	  return ajax({ url, data, method: 'post' })
	},
	/**
	 * 11.11设置分组为公共组
	 */
	setcommongroup( data ){
	  const url = "/group/setcommongroup"
	  return ajax({ url, data, method: 'post' })
	}
}
